import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { Store } from '@ngrx/store';

import { setWorkspaceIdSource } from './workspace-link';
import { AppSelectors } from '../../../store/app/app.selectors';

/**
 * Points `wsLink` at the store — an initializer, not a component hook, because links are built
 * during the first navigation.
 */
export function provideWorkspaceLink(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const selectedWorkspaceId = inject(Store).selectSignal(AppSelectors.selectedWorkspaceId);

    setWorkspaceIdSource(() => selectedWorkspaceId());
  });
}
